import { useSelector } from 'react-redux';

const useHasMissingRequiredPersonalData = () => {
  const { isAuthenticated, account } = useSelector((state) => state.auth);

  if (!isAuthenticated || !account) {
    return false;
  }

  const isEmpty = (v) => v === null || v === undefined || v === '';

  const userFieldsMissing = isEmpty(account.birthLastName)
    || isEmpty(account.birthFirstName)
    || isEmpty(account.motherBirthLastName)
    || isEmpty(account.motherBirthFirstName)
    || isEmpty(account.birthPlace)
    || isEmpty(account.birthDate);

  const contactFieldsMissing = !account.contactDetail
    || isEmpty(account.contactDetail.addressType);

  return userFieldsMissing || contactFieldsMissing;
};

export default useHasMissingRequiredPersonalData;
